import { shouldEncryptTransmission } from "@/config";

// 加密接口映射配置
// 所有需要加密的接口，都要在这里进行配置
const API_PATH_MAP = {
    getCompanyInfo: {
        encrypted: "/api/auth/user/enc/company/info",
        normal: "/api/auth/user/company/info",
    },
    getUserInfo: {
        encrypted: "/api/auth/user/enc/info",
        normal: "/api/auth/user/info",
    },
    sendCaptchas: {
        encrypted: "/api/guest/auth/login/enc/mobile-captchas/send",
        normal: "/api/auth/login/mobile-captchas/send",
    },
    login: {
        encrypted: "/api/guest/auth/login/enc/mobile",
        normal: "/api/auth/login/mobile",
    },
    bindWeixin: {
        encrypted: "/api/guest/weixin/enc/bind",
        normal: "/api/auth/weixin/bind",
    },
    refreshToken: {
        encrypted: "/api/guest/auth/login/enc/token/refresh",
        normal: "/api/auth/login/token/refresh",
    },
    cancelBusiness: {
        encrypted: "/api/auth/user/enc/business/cancel",
        normal: "/api/auth/user/business/cancel",
    },
}

// 使用 Proxy 动态返回接口地址，调用方不用通过函数式调用，直接使用：ENCRYPT_APIS.xxx
export const ENCRYPT_APIS = new Proxy({} as Record<keyof typeof API_PATH_MAP, string>, {
    get(_, prop: keyof typeof API_PATH_MAP) {
        console.log('获取属性: ', prop);
        const pathConfig = API_PATH_MAP[prop];
        if (!pathConfig) {
            throw new Error(`API path "${String(prop)}" not found`);
        }
        return shouldEncryptTransmission() ? pathConfig.encrypted : pathConfig.normal;
    },
});